import { formModeEnum } from '@/types/general';

import { settingsBreadcrumbs } from '../settings-breadcrumbs';

import type { RouteRecordInfo } from 'vue-router';

const channels_routes = [
  {
    path: 'channels',
    name: 'channels',
    meta: {
      permissions: 'read-channels',
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.channels_trans',
        route: { name: 's-channels' },
      }),
    },
    children: [
      {
        path: '',
        name: 's-channels',
        component: () => import('@/views/System/Settings/Channels/ChannelList.vue'),
        meta: {
          permissions: 'read-channels',
        },
      },
      {
        path: 'add',
        name: 's-channels-add',
        component: () => import('@/views/System/Settings/Channels/AddChannel.vue'),
        meta: {
          permissions: 'write-channels',
        },
        redirect: { name: 's-channels-list' },
        children: [
          {
            path: '',
            name: 's-channels-list',
            component: () => import('@/views/System/Settings/Channels/Components/ChannelsBoxes.vue'),
            meta: {
              permissions: 'write-channels',
            },
          },
          {
            path: ':channel',
            name: 's-channels-add-page',
            component: () => import('@/views/System/Settings/Channels/Components/AddChannelDynamicView.vue'),
            meta: {
              permissions: 'write-channels',
            },
            props: (route: RouteRecordInfo) => {
              return { channelName: route.params.channel };
            },
          },
          {
            path: ':channel_id/users',
            name: 's-channels-add-users',
            component: () => import('@/views/System/Settings/Channels/Components/AssignUsers.vue'),
            meta: {
              permissions: 'write-channels',
            },
          },
          {
            path: ':channel_id/final',
            name: 's-channels-add-final',
            component: () => import('@/views/System/Settings/Channels/Components/FinalStep.vue'),
            meta: {
              permissions: 'write-channels',
            },
          },
        ],
      },
      {
        path: ':channelType/:channelId',
        name: 's-channels-edit',
        component: () => import('@/views/System/Settings/Channels/EditChannel.vue'),
        meta: {
          permissions: 'update-channels',
        },
        redirect: { name: 's-channel-edit-settings' },
        children: [
          {
            path: 'settings',
            name: 's-channel-edit-settings',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/SettingsTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'collaborators',
            name: 's-channel-edit-collaborators',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/CollaboratorsTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'templates',
            name: 's-channel-edit-templates',
            component: () =>
              import('@/views/System/Settings/Channels/Components/SettingsPage/templates/TemplatesTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'add-template',
            name: 's-channel-edit-template-add',
            component: () =>
              import('@/views/System/Settings/Channels/Components/SettingsPage/templates/TemplateForm.vue'),
            meta: {
              formType: formModeEnum.ADD,
              permissions: 'update-channels',
              hideChannelLayout: true,
            },
          },
          {
            path: 'edit-template/:id',
            name: 's-channel-edit-template-edit',
            component: () =>
              import('@/views/System/Settings/Channels/Components/SettingsPage/templates/TemplateForm.vue'),
            meta: {
              formType: formModeEnum.EDIT,
              permissions: 'update-channels',
              hideChannelLayout: true,
            },
          },
          {
            path: 'ongoingmessage',
            name: 's-channel-edit-ongoingmessage',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/OngoingMessageTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'commerce',
            name: 's-channel-edit-commerce',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/CommerceTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'configuration',
            name: 's-channel-edit-configuration',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/ConfigurationTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'prechat',
            name: 's-channel-edit-prechat',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/PreChatFormTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
          {
            path: 'widgetbuilder',
            name: 's-channel-edit-widgetbuilder',
            component: () => import('@/views/System/Settings/Channels/Components/SettingsPage/WidgetBuilderTab.vue'),
            meta: {
              permissions: 'update-channels',
            },
          },
        ],
      },
    ],
  },
];

export default channels_routes;
